import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getUserByUsername = async fields => {
    const response = {user: null, error: null}
    try {
      const {body: {user, error}} = await Api.post('/user/getByUsername', fields)
      if (!error && user) {
        response.user = user
      } else {
        response.error = error
      }
    } catch (e) {
      response.error = e
    }
    return response
  }

  getUserBySeo = async fields => {
    const response = {user: null, error: null}
    try {
      const {body: {user, error}} = await Api.post('/user/getBySeo', fields)
      if (!error && user) {
        response.user = user
      } else {
        response.error = error
      }
    } catch (e) {
      response.error = e
    }
    return response
  }
}
